import React from 'react'
import { connect } from 'react-redux'
import pure from 'recompose/pure'
import PaymentContainer from './PaymentContainer'

const PaymentsModule = pure(function PaymentsModule({ isPaymentModalOpen, platform }) {
    return isPaymentModalOpen && <PaymentContainer platform={platform} />
})

const mapStateToProps = state => ({
    isPaymentModalOpen: state.getIn(['payments', 'isPaymentModalOpen']),
    platform: state.getIn(['payments', 'platform']),
})

const PaymentsModuleContainer = connect(mapStateToProps)(PaymentsModule)

export default PaymentsModuleContainer
